var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnReplacementRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0683 9.985C15.2896 10.2063 15.2896 10.5651 15.0683 10.7864L12.4016 13.4531C12.1803 13.6744 11.8215 13.6744 11.6002 13.4531C11.3789 13.2318 11.3789 12.873 11.6002 12.6517L14.2669 9.985C14.4882 9.76371 14.847 9.76371 15.0683 9.985Z",
    fill: "#E50B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.767578 10.3857C0.767578 10.0727 1.02128 9.81903 1.33424 9.81903H14.6676C14.9805 9.81903 15.2342 10.0727 15.2342 10.3857C15.2342 10.6987 14.9805 10.9524 14.6676 10.9524H1.33424C1.02128 10.9524 0.767578 10.6987 0.767578 10.3857Z",
    fill: "#E50B20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40161 2.54781C4.6229 2.76911 4.6229 3.1279 4.40161 3.3492L1.73494 6.01586C1.51364 6.23716 1.15485 6.23716 0.933551 6.01586C0.712254 5.79457 0.712254 5.43577 0.933551 5.21448L3.60022 2.54781C3.82151 2.32651 4.18031 2.32651 4.40161 2.54781Z",
    fill: "#E50B20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.767578 5.61517C0.767578 5.30221 1.02128 5.0485 1.33424 5.0485H14.6676C14.9805 5.0485 15.2342 5.30221 15.2342 5.61517C15.2342 5.92813 14.9805 6.18184 14.6676 6.18184H1.33424C1.02128 6.18184 0.767578 5.92813 0.767578 5.61517Z",
    fill: "#E50B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnReplacementRedIcon);
export default __webpack_public_path__ + "static/media/return-replacement-red-icon.70e669b2b3b4bf747ee63e1c0ac23399.svg";
export { ForwardRef as ReactComponent };